import { closeLastOpenedPopupByMapId } from '@redux/maps/maps.reducer';
import { useHotkeys } from 'react-hotkeys-hook';

import { MapIdEnum } from '@/types/map.types';

import { useWithDispatch } from './useWithDispatch';

export const useCloseLastOpenedPopup = (mapId: MapIdEnum) => {
  const closeLastOpenedPopup = useWithDispatch(closeLastOpenedPopupByMapId);

  useHotkeys('ctrl+backspace', () => {
    closeLastOpenedPopup(mapId);
  });
};
